import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { ChatMessage } from "../models/ChatMessage";

export const useGetMessages = (chatId: string) => {
  const { data: messages, call } = useApiPrivateRequest<ChatMessage[]>(
    (response) => response.map((message: any) => new ChatMessage(message)),
  );
  const getMessages = async () => {
    await call(`/chats/${chatId}/messages`, "GET");
  };

  return { messages, getMessages };
};
